<svelte:options
	customElement={{
		tag: "favorite-list-button",
		shadow: "none",
	}}
/>

<script lang="ts">
	import tippy from "svelte-tippy";

	import { initFluentContext, localize, Localized } from "@/localization";
	import SvgIcon from "@/components/svg-icon.svelte";
	import { store } from "./store";

	interface Props {
		size: "small" | "large";
		favoritelisturl: string;
		galleryurl: string;
	}

	let { size, favoritelisturl, galleryurl }: Props = $props();

	let count = $derived(store.size);

	initFluentContext();
</script>

{#if size === "large"}
	<div class="is-flex">
		<a class="button is-mint header-action is-flex-grow-1" href={galleryurl} use:tippy={{ content: localize("gallery-button.tooltip") }}>
			<SvgIcon customClass="icon--gallery" size="is-large" icon="paginate-filter-picture-alternate" />
			<span class="button__label"><Localized id="gallery-button" /></span>
		</a>
		<a class="button is-primary header-action header-action--slim" href={favoritelisturl} use:tippy={{ content: localize("favorite-list-button.tooltip") }}>
			<SvgIcon customClass="icon--favorite-list" size="is-large" icon="filter-heart" badgeValue={count} />
		</a>
	</div>
{:else if size === "small"}
	<div class="is-flex">
		<a class="button is-mint header-action is-flex-grow-1" href={galleryurl} use:tippy={{ content: localize("gallery-button.tooltip") }}>
			<SvgIcon customClass="icon--gallery" size="is-medium" icon="paginate-filter-picture-alternate" />
			<span class="button__label"><Localized id="gallery-button.label-short"/></span>
		</a>
		<a class="button is-primary header-action header-action--slim" href={favoritelisturl} use:tippy={{ content: localize("favorite-list-button.tooltip") }}>
			<SvgIcon customClass="icon--favorite-list" size="is-medium" icon="filter-heart" badgeValue={count} />
		</a>
	</div>
{/if}
